import React from 'react'

function Instagram() {
  return (
    <div>
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0403 0.51001H6.82019C3.32019 0.51001 0.450195 3.37988 0.450195 6.87988V16.1001C0.450195 19.6001 3.32019 22.47 6.82019 22.47H16.0403C19.5403 22.47 22.4103 19.6001 22.4103 16.1001V6.87988C22.4103 3.37988 19.5403 0.51001 16.0403 0.51001ZM11.4303 17.45C8.1403 17.45 5.47021 14.78 5.47021 11.49C5.47021 8.19999 8.1403 5.53003 11.4303 5.53003C14.7203 5.53003 17.3903 8.19999 17.3903 11.49C17.3903 14.78 14.7203 17.45 11.4303 17.45ZM18.1803 6.52002C17.2803 6.52002 16.5503 5.78989 16.5503 4.88989C16.5503 3.98989 17.2803 3.26001 18.1803 3.26001C19.0803 3.26001 19.8103 3.98989 19.8103 4.88989C19.8103 5.78989 19.0803 6.52002 18.1803 6.52002Z"/>
        <path d="M11.4304 16.0801C13.9654 16.0801 16.0204 14.025 16.0204 11.49C16.0204 8.955 13.9654 6.8999 11.4304 6.8999C8.89543 6.8999 6.84033 8.955 6.84033 11.49C6.84033 14.025 8.89543 16.0801 11.4304 16.0801Z"/>
        </svg>
    </div>
  )
}


export default Instagram